import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ApiService } from '../../../core/services/api/api.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private authToken: string | null = null;

  constructor(private apiService: ApiService) {
  }

  login(email: string, password: string): Observable<void> {
    if (!email || !password) {
      return throwError(() => new Error('Missing credentials.'));
    }
    
    return this.apiService.apipost('auth/login', { username: email, password }).pipe(
      map((response: any) => {
        if (response.status) {
          this.authToken = response.token || null;
          if (this.authToken) {
            // Store token temporarily until VSAC verification
            localStorage.setItem('temp_auth_token', this.authToken);
          }
        } else {
          throw new Error(response.message || 'Login failed');
        }
      })
    );
  }



  sendVSAC(): Observable<any> {
    if (!this.authToken) {
      return throwError(() => new Error('No authentication token available.'));
    }
    
    return this.apiService.apipost('auth/sendVSAC');
  }

  verifyVSAC(vsacInput: string): Observable<any> {
    if (!this.authToken) {
      return throwError(() => new Error('No authentication token available.'));
    }
    
    return this.apiService.apipost('auth/verifyVSAC', { vsacInput }).pipe(
      map((response: any) => {
        if (response.status) {
          // VSAC verification successful - move token from temp to permanent
          const tempToken = localStorage.getItem('temp_auth_token');
          if (tempToken) {
            localStorage.setItem('auth_token', tempToken);
            localStorage.removeItem('temp_auth_token');
          }
        }
        return response;
      })
    );
  }

  resendVSAC(): Observable<any> {
    if (!this.authToken) {
      return throwError(() => new Error('No authentication token available.'));
    }
    
    return this.apiService.apipost('auth/resendVSAC');
  }

  logout(): void {
    this.authToken = null;
    localStorage.removeItem('auth_token');
    localStorage.removeItem('temp_auth_token');
  }

  isVerified(): boolean {
    return !!localStorage.getItem('auth_token');
  }

  hasTempToken(): boolean {
    return !!localStorage.getItem('temp_auth_token');
  }

  isAuthenticated(): boolean {
    return this.isVerified() || this.hasTempToken();
  }
}


